import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

export const ArrowBack:React.FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="currentColor" fill="transparent" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>
)
